import React from "react";
import {css} from "@emotion/react";

import {w100, zIndex} from "@pg-design/helpers-css";
import {calculateRemSize} from "@pg-design/helpers-css-strings";
import {Picture} from "@pg-design/picture-module";

import {InvestmentOfferHeaderContent} from "./InvestmentOfferHeaderContent";

const headerXl = require("../images/header_xl.png");
const headerLg = require("../images/header_lg.png");
const headerMd = require("../images/header_md.png");
const headerSm = require("../images/header_sm.png");
const headerXs = require("../images/header_xs.png");

export const InvestmentOfferHeader = () => {
    return (
        <>
            <section css={investmentOfferHeader}>
                <Picture
                    sources={[
                        {minWidthPX: 0, src: headerXs, height: 512, width: 360},
                        {minWidthPX: 370, src: headerSm, height: 512, width: 600},
                        {minWidthPX: 600, src: headerMd, height: 512, width: 1377},
                        {minWidthPX: 1377, src: headerLg, height: 512, width: 1920},
                        {minWidthPX: 1920, src: headerXl, height: 512, width: 2556}
                    ]}
                    alt="header"
                    fit="top left"
                />

                <div css={investmentOfferHeaderContentPositioner}>
                    <InvestmentOfferHeaderContent />
                </div>
            </section>
        </>
    );
};

const investmentOfferHeader = css`
    position: relative;
    height: 512px;
`;

const investmentOfferHeaderContentPositioner = css`
    position: absolute;
    left: 0;
    top: ${calculateRemSize(12)};
    ${w100};
    ${zIndex(10)};
`;
import React from "react";
import {css} from "@emotion/react";

import {w100, zIndex} from "@pg-design/helpers-css";
import {calculateRemSize} from "@pg-design/helpers-css-strings";
import {Picture} from "@pg-design/picture-module";

import {InvestmentOfferHeaderContent} from "./InvestmentOfferHeaderContent";

const headerXl = require("../images/header_xl.png");
const headerLg = require("../images/header_lg.png");
const headerMd = require("../images/header_md.png");
const headerSm = require("../images/header_sm.png");
const headerXs = require("../images/header_xs.png");

export const InvestmentOfferHeader = () => {
    return (
        <>
            <section css={investmentOfferHeader}>
                <Picture
                    sources={[
                        {minWidthPX: 0, src: headerXs, height: 512, width: 360},
                        {minWidthPX: 370, src: headerSm, height: 512, width: 600},
                        {minWidthPX: 600, src: headerMd, height: 512, width: 1377},
                        {minWidthPX: 1377, src: headerLg, height: 512, width: 1920},
                        {minWidthPX: 1920, src: headerXl, height: 512, width: 2556}
                    ]}
                    alt="header"
                    fit="top left"
                />

                <div css={investmentOfferHeaderContentPositioner}>
                    <InvestmentOfferHeaderContent />
                </div>
            </section>
        </>
    );
};

const investmentOfferHeader = css`
    position: relative;
    height: 512px;
`;

const investmentOfferHeaderContentPositioner = css`
    position: absolute;
    left: 0;
    top: ${calculateRemSize(12)};
    ${w100};
    ${zIndex(10)};
`;
